import { AttendContactLeaveEarlyFactory } from './attendContactLeaveEarlyFactory';

import type {
  AttendContactLeaveEarlyEntity,
  AttendContactLeaveEarlyPropsPub,
  AttendContactLeaveEarlyPropsPvt,
} from './attendContactLeaveEarlyEntity';
import type { AttendContactLeaveEarlyIRepository } from './attendContactLeaveEarlyIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { AttendContactLeaveEarlyJsonPub, AttendContactLeaveEarlyJsonPvt } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class AttendContactLeaveEarlyRepository extends AppsyncRepository<
  AttendContactLeaveEarlyEntity,
  AttendContactLeaveEarlyPropsPvt,
  AttendContactLeaveEarlyJsonPvt,
  AttendContactLeaveEarlyPropsPub,
  AttendContactLeaveEarlyJsonPub
> implements AttendContactLeaveEarlyIRepository {
  private factory = new AttendContactLeaveEarlyFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryAttendContactAttendContactLeaveEarlyEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
